export default __webpack_public_path__ + "static/media/x.af9d54fe.svg";